import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Mousewheel } from 'swiper/modules';

class actDeepLoadmore {
  Swipes = null;
  constructor() {
    const loadMore = document.querySelector('.js-deep-load-btn');
    const articles = document.querySelectorAll('.js-act-deeper');
    if (loadMore) {
      loadMore.addEventListener('click', () => {
        articles.forEach((article) => {
          article.classList.remove('d-md-none');
        });
        loadMore.classList.remove('d-md-block');
      });
    }
    this.sliderInit();
    this.resize();
  }

  sliderInit() {
    if (window.innerWidth < 768) {
      if (this.Swipes) {
        this.Swipes.enable();
      } else {
        Swiper.use([Navigation, Pagination, Autoplay, Mousewheel]);
        this.Swipes = new Swiper('.act-deeper-slider', {
          slidesPerView: 1,
          grabCursor: true,
          loop: false,
          speed: 500,
          allowTouchMove: true,
          spaceBetween: 13,
          // autoHeight: true,
          mousewheel: {
            releaseOnEdges: true,
            forceToAxis: true,
          },

          pagination: {
            el: '.act-deeper-slider .slider__pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.act-deeper-slider .slider__button-next',
            prevEl: '.act-deeper-slider .slider__button-prev',
          },
        });
      }
    } else {
      if (this.Swipes) {
        this.Swipes.disable();
        this.Swipes.setProgress(0);
      }
    }
  }
  resize() {
    window.addEventListener('resize', () => {
      this.sliderInit();
    });
  }
}

export default actDeepLoadmore;
new actDeepLoadmore();
